// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerInner":"Footer_footerInner__Lmt4V","brand":"Footer_brand__QKAvM","contact":"Footer_contact__WmEl1","copy":"Footer_copy__V37yO"};